import PropTypes from 'prop-types';

export default {
  recommendation: PropTypes.shape({
    comment: PropTypes.string,
    ranking: PropTypes.number,
    person: PropTypes.shape({
      id: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      avatar_name: PropTypes.string,
      is_author: PropTypes.bool,
    }),
  }),
};
